import React, { ReactNode, ReactElement } from "react";
import CompanyWrapper from "./components/data/CompanyWrapper";
import EmployeesWrapper from "./components/data/EmployeesWrapper";
import BenefitPlansWrapper from "./components/data/BenefitPlanWrapper";
import ModalWrapper from "./components/ModalWrapper";
import TaxRegimesWrapper from "./components/data/TaxRegimesWrapper";
import EmployeeActionWrapper from "./components/actions/EmployeeActionsWrapper";
import RecurrentPaymentActionWrapper from "./components/actions/RecurrentPaymentActionsWrapper";
import LoaderProvider from "../../app/components/LoaderProvider";
import RecurrentPaymentsWrapper from "./components/data/RecurrentPaymentsWrapper";

const DataWrappers = ({ children }: { children: ReactNode }): ReactElement => {
  return (
    <CompanyWrapper>
      <TaxRegimesWrapper>
        <BenefitPlansWrapper>
          <EmployeesWrapper>
            <RecurrentPaymentsWrapper>{children}</RecurrentPaymentsWrapper>
          </EmployeesWrapper>
        </BenefitPlansWrapper>
      </TaxRegimesWrapper>
    </CompanyWrapper>
  );
};

const ActionsWrapper = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  return (
    <EmployeeActionWrapper>
      <RecurrentPaymentActionWrapper>{children}</RecurrentPaymentActionWrapper>
    </EmployeeActionWrapper>
  );
};

export default function ContextsProvider({
  children,
}: {
  children: any;
}): ReactElement {
  return (
    <ModalWrapper>
      <DataWrappers>
        <ActionsWrapper>
          <LoaderProvider>{children}</LoaderProvider>
        </ActionsWrapper>
      </DataWrappers>
    </ModalWrapper>
  );
}
